/**
 * Application client d'authentification des enquêtes ISQ
 * https://collecteweb.unit.stat/web2/COLLECTE -ModRewrite-> /scd/html/authentification/index.html
 */
import React, { Component } from 'react';

import { chainesLocales } from './include/chainesLocales';
import { getJson } from './service/serviceUtil';
import { URL_API }  from './include/urlApi.js';

import Modal from './components/modal';
import Page from './components/page';
import PIV from './components/piv';

import './App.css';

/**
 * Cette classe permet de construire une page du processus d'authentification.
 * 
 * @author Frédéric Auger
 * @class App
 * @extends {Component}
 *
 * @since 0.1.0
 */
class App extends Component {
    constructor(props) {
        super(props);

        // Handler sur les events message pour le changement de langue Voxco
        this.messageHandler = this.messageHandler.bind(this);

        // Handler pour les fenêtres modales
        this.showModalHandler = this.showModalHandler.bind(this);

        // Fenêtres modales
        this.modals = {
            "consignes": require('./modals/consignesModal').default,
            "nous-joindre": require('./modals/nousJoindreModal').default
        };

        // Pages de l'autentification
        this.pages = {
            "bienvenue": require('./pages/bienvenue').default,
            "consignes": require('./pages/consignes').default,
            "demande-identifiant": require('./pages/demandeIdentifiant').default,
            "demande-mot-passe": require('./pages/demandeMotPasse').default,
            "creer-mot-passe": require('./pages/creerMotPasse').default,
            "creer-courriel": require('./pages/creerCourriel').default,
            "verif-courriel": require('./pages/verifCourriel').default,
            "questionnaire": require('./pages/questionnaire').default,
            "quitteQuestionnaire": require('./pages/quitteQuestionnaire').default,
            "erreur404": require('./pages/erreur404').default,
            "erreurPause": require('./pages/erreurPause').default,
            "erreurTermine": require('./pages/erreurTermine').default,
            "sessionTermine": require('./pages/sessionTermine').default,
            "erreurSupport": require('./pages/erreurSupport').default,
            "send-recovery-code": require('./pages/sendRecoveryCode').default,
            "verif-recovery-code": require('./pages/verifRecoveryCode').default,
            "confirm-recovery-code": require('./pages/confirmRecoveryCode').default
        };

        // Parsed url et params get
        let parsedHref = window.location.href.split("/").reverse();
        let parsedParams = (parsedHref[0] || "").split("?");

        // Suffixe de la collecte passé dans le url
        let suffixeCourant = parsedParams[0] || "";

        // Page passée dans le url (présentement utilisé seulement pour les pages lienExterne, sessionTermine, quitteQuestionnaire et erreur404)
        let paramPage = /(^page=|&page=)([^&?=]*)($|&|\?)/i.exec(parsedParams[1] || "") || [];
        let pageValue = paramPage[2] || null;

        // Action a effectuer dans le cas ou la session voxco est terminée dans le iframe (une page autre que le questionnaire est affichée), que le questionnaire est terminé (une page autre que le questionnaire est affichée) 
        // ou que l'utilisateur a clické sur le bouton Quitter
        let paramAction = /(^action=|&action=)([^&?=]*)($|&|\?)/i.exec(parsedParams[1] || "") || [];
        let actionValue = paramAction[2] || null;

        // Url à charger dans le cas ou l'action est redirect et que la page est lienExterne
        let paramUrl = /(^url=|&url=)([^&?=]*)($|&|\?)/i.exec(parsedParams[1] || "") || [];
        let urlValue = paramUrl[2] || null;

        this.state = {
            lngChild : undefined,
            suffixe: suffixeCourant, // suffixe de la collecte passé dans le url
            langues: undefined,
            lang: undefined,   /* obtenus lors */
            status: undefined, /* de l'appel   */
            logo: {},          /* à l'API      */
            config: {},        /* PHP          */
            user: {
                username: "",              // nom d'utilisateur entré par l'internaute
                useremail: "",             // Courriel de l'utilisateur
                passwordStatus: undefined, // status du mot de passe (defini, temporaire ou inexistant)
                hasEmail: false,           // si l'utilisateur a un email de défini
                tokenCMP: undefined,       // CSRF Token pour creer le mot de passe
                tokenCourriel: undefined,  // CSRF Token pour ajouter le courriel
                hasDefinedQuestion: false,
                hasDefinedSecret: false,
                hasDefinedMail: false
            },
            modal: {
                page: "",   /* fenêtre */
                open: false /* modale  */
            },
            page: "bienvenue",
            mode: (window.parent !== window) ? "iframe" : "panel", // iframe : page dans le iframe autre que le questionnaire | fullscreen : questionnaire dans le iframe | panel : toutes autres pages (dans un carré blanc)
            action: actionValue || "reload",  // action a effectuer dans le cas ou la session voxco est terminée dans le iframe ou que l'utilisateur a clické sur le bouton Quitter (reload ou redirect)
            paramsGet: parsedParams[1] || "", // params get passés dans le url
            paramPage: pageValue,             // page passée dans les params get
            paramUrl: urlValue,               // url passé dans les params get (pour action=redirect&page=lienExterne)
            noLangButton: [
              "mine1af", "mine1ae",
              "mine2af", "mine2ae",
              "mine3af", "mine3ae",
              "mine4af", "mine4ae",
              "mine12mf", "mine12me",
              "mine11mf", "mine11me",
              "mine10mf", "mine10me",
              "mine9mf", "mine9me",
              "mine8mf", "mine8me",
              "mine7mf", "mine7me",
              "mine6mf", "mine6me",
              "mine5mf", "mine5me",
              "mine4mf", "mine4me",
              "mine3mf", "mine3me",
              "mine2mf", "mine2me",
              "mine1mf", "mine1me"
            ] // Suffixe des enquêtes pour lesquelles il ne faut pas afficher le bouton de changement de langue dans le mode fullscreen
        };
    }

    get labels() {
        return chainesLocales['App'][(this.props.lang || 'FR')];
    }

    componentDidUpdate() {
        if (document.querySelector && document.body.classList) {
            // Cacher le menu sandwich
            document.querySelector('#menuPiv').classList.remove('show');

            // Cacher l'image de fond si le questionnaire voxco est affiché
            if (this.state.mode === "fullscreen") {
                document.querySelector('body').classList.add('no-background');
            } else {
                document.querySelector('body').classList.remove('no-background');
            }
        }
    }

    componentDidMount() {
        // Listener sur les events message pour le changement de langue Voxco
        window.addEventListener("message", this.messageHandler);

        // Éliminer les paramètres get du url et ne garder que le suffixe de la collecte
        if (window.history.replaceState) window.history.replaceState({paramPage: this.state.paramPage, paramsGet: this.state.paramsGet, action: this.state.action}, "Authentification", this.state.suffixe);
        
        // Gestion des erreurs javascript
        window.onerror = function(message, source, lineno, colno, error) {
            console.error("Erreur JS: [message: '" + message + "', source: '" + source + "', lineno: " + lineno + ", colno: " + colno + ", error: '" + error + "']");

            return true;
        };

        // Si nous ne sommes pas dans le iframe (ouverture normal de l'authentification)
        if (this.state.mode !== "iframe") {
            if (this.state.paramPage === 'sessionTermine' || this.state.paramPage === 'quitteQuestionnaire' || this.state.paramPage === 'erreur404') {
                console.log("[page: " + this.state.paramPage + ", collecte: " + this.state.suffixe + "]");

                this.setState({lang: this.state.lang || 'FR', page: this.state.paramPage});
            } else {
                let defaultParams = {
                    suffixe: this.state.suffixe
                };

                // Obtenir le status de la collecte
                getJson('collecteStatus', defaultParams).then(status => {
                    switch (status) {
                        case "": 
                            // Collecte inexistante (ou problèmes avec l'appel de l'API PHP)
                            this.setState({status, lang: 'FR', page: "erreur404"});
                            break;

                        case "incompatible":
                            // Fureteur non supporté
                            this.setState({status, lang: 'FR', page: "erreurSupport"});
                            break;

                        default:
                            // Obtenir la langue, le logo et les paramètres de la collecte
                            Promise.all([getJson('collecteLangues', defaultParams),getJson('collecteLangue', defaultParams), getJson('collecteParameters', defaultParams), getJson('logo', defaultParams)]).then(([langues, lang, config, logo]) => {
                                let page = "";

                                switch (status) {
                                    case "ACTIF":
                                        page = "bienvenue";                      
                                        break;

                                    case "INACTIF":
                                        page = "erreurTermine";
                                        break;

                                    default:
                                        page = "erreurPause";
                                        break;
                                }
                                
                                // Afficher la page de bienvenue de la collecte
                                this.setState({ langues: langues, page, status, lang: lang || 'FR', lngChild: lang || 'FR', config: config || {}, logo: logo || {} });
                                document.querySelector('html').setAttribute('lang', lang.toLowerCase()==='an'?'en':lang.toLowerCase());
                            }).catch((err) => {
                                console.error("Erreur API parameters: " + err);

                                this.setState({lang: 'FR', page: 'erreur404'});
                            });

                            break;
                    }
                }).catch((err) => {
                    console.error("Erreur API status: " + err);

                    this.setState({lang: 'FR', page: 'erreur404'});
                });
            }
        } else {
            console.info("iframe action " + this.state.action);

            if (this.state.action === "reload") {
                window.parent.location.replace(`${URL_API}?action=reload&suffixe=${this.state.suffixe}`);
            } else if (this.state.action === "concours") {
                window.parent.location.replace(`${URL_API}?action=concours&suffixe=${this.state.suffixe}`);
            } else if (this.state.action === "redirect" && this.state.paramPage === "sessionTermine") {
                window.parent.location.replace('/web2/' + this.state.suffixe + '?page=sessionTermine');
            } else if (this.state.action === "redirect" && this.state.paramPage === "lienExterne" && this.state.paramUrl) {
                window.parent.location.replace(`${URL_API}?action=redirect&suffixe=${this.state.suffixe}&url=${this.state.paramUrl}`);
            } else if (['defaut', 'complete', 'elimine', 'interrompu', 'quota', 'inactif', 'reacces', 'panic'].includes(this.state.action) && this.state.paramPage === "quitteQuestionnaire") {
                window.parent.location.replace('/web2/' + this.state.suffixe + '?page=quitteQuestionnaire&action=' + this.state.action);
            } else {
                window.parent.location.replace('/web2/' + this.state.suffixe + '?page=erreur404');
            }
        }
    }
    /**
     * Cleanup on unmount
     */
    componentWillUnmount() {
        // Enlever le listener de messages
        removeEventListener("message", this.messageHandler);
    }
    
    render() {
        let { lang } = this.state;
        
        if (lang) {
            let langueImpose = this.state.config["LANG_IMPOSE"] === 'O' ? true : false;

            return (
                <div className="App">
                    {this.state.mode === "iframe" ? null : 
                    <React.Fragment>
                        <Modal open={this.state.modal.open} onClose={this.onModalClose.bind(this)}>
                        {
                            this.getCurrentModalComponent()
                        }
                        </Modal>
                        <PIV
                        lang={lang}
                        langues={this.state.langues}
                        lngChild={this.state.lngChild}  
                        user={this.state.user} 
                        status={this.state.status} 
                        lienAnnexe={this.state.config[`URL_ANNEXE_${this.state.lngChild}`]} 
                        lienDefinitions={this.state.config[`URL_DEFINITIONS_${this.state.lngChild}`]} 
                        lienGuide={this.state.config[`URL_GUIDE_${this.state.lngChild}`]} 
                        lienConfid={this.state.config[`URL_CONFID_${this.state.lngChild}`]} 
                        lienFaq={this.state.config[`URL_FAQ_${this.state.lngChild}`]} 
                        viewMode={this.state.mode} 
                        showLandButton={this.state.noLangButton.includes(this.state.suffixe) ? ['panel', 'iframe'] : ['panel', 'fullscreen', 'iframe']} 
                        canQuitSurvey={this.state.mode === "fullscreen" ? true : false} 
                        canToggleLang={!langueImpose} showGuidelines={this.state.config["MES_CONS"]} 
                        showModal={this.showModalHandler} 
                        onToggleLang={this.onToggleLangHandler.bind(this)} 
                        onQuitSurvey={this.onQuitSurveyHandler.bind(this)} />
                    </React.Fragment>}
                    <Page lang={lang} suffixe={this.state.suffixe} showModal={this.showModalHandler} showHelpText={this.state.status === "ACTIF" ? true : false} viewMode={this.state.mode}>
                    {
                        this.getCurrentPageComponent()
                    }
                    </Page>
                </div>
            );
        } else {
            return (
                <div className="w-100 h-100 d-table">
                    <div className="d-table-cell text-white text-center align-middle"><h1>{this.labels.loadingText}</h1></div>
                </div>
            );
        }
    }

        /** 
    * Changement de langue provenant de Voxco
    * Appelle le bouton de changement de langue dans le PIV
    * Le sélecteur de langue 'language_selector' du PIV est présent au démarrage et est caché après un logon réussi
    * Le sélecteur de langue 'language_selectorVoxco' du PIV est touours caché
    */
    messageHandler(event) {
        var url = document.URL.split('/web2')[0];
        if (url != undefined) {
            const origin = event.origin.split('/web2')[0]
            if (event.origin !== url) {
                console.log('Erreur event.origin:' + event.origin);
                return;
            }
            if (event.data && event.data.type === 'IFRAME_CHANGEMENT_LANGUE') {
                let voxcoLng = event.data.payload.toUpperCase();
                voxcoLng == 'EN' ? voxcoLng = 'AN':voxcoLng == 'CR' ? voxcoLng = 'CR': voxcoLng == 'CS'? voxcoLng='CS':voxcoLng = 'FR';
                let language_selector = document.getElementById('language_selector');
                let language_selectorVoxco = document.getElementById('language_selectorVoxco');
                if (language_selector) {
                    language_selector.setAttribute('hidden', true);
                    let language_selectorValue = language_selector.value.toUpperCase();
                    console.log('language_selectorValue:' + language_selectorValue)
                    console.log('voxcoLng:' + voxcoLng)
                    if (voxcoLng != language_selectorValue) {
                        language_selector.value = voxcoLng;
                        language_selectorVoxco.value = voxcoLng;
                        language_selectorVoxco.click();
                        console.log('Langue Voxco changée');
                    }
                }
            }
        }
    };

    onQuitSurveyHandler() {
        getJson('detruireSession').then((retour) => {
            if (retour === true) {
                console.info("session detruite");
            } else {
                console.error("Erreur API detruire session");
            }
        }).catch((err) => {
            console.error("Erreur API quitte questionnaire: " + err);
        });

        console.info("quitte action " + this.state.action);

        if (this.state.action === "reload") {
            window.location.reload();
        } else if (this.state.action === "redirect") {
            window.location.replace('/web2/' + this.state.suffixe + '?page=sessionTermine');
        } else {
            window.location.replace('/web2/' + this.state.suffixe + '?page=erreur404');                
        }
    }

	onToggleLangHandler(lng, fromVoxco=false) {
        var htmlLng = lng.toLowerCase() === 'an'? 'en':lng.toLowerCase();
        //On place la langue du PIV, reçue de Voxco ou du bouton de langue du PIV
        this.setState({ lngChild: lng.toUpperCase() }, () => {
            if (document.querySelector && document.body.setAttribute) 
                {document.querySelector('html').setAttribute('lang', htmlLng)};
        });
        //Langue non reçue de Voxco, on place la langue dans la page web d'authentification 
        if (!fromVoxco) {
            this.setState({ lang: lng}, () => {
                if (document.querySelector && document.body.setAttribute) 
                {document.querySelector('html').setAttribute('lang', htmlLng);}
            });
        }
    }

    showModalHandler(newModal) {
        this.setState({
            modal: {
                page: newModal,
                open: true
            }
        });
    }

    onModalClose() {
        let modalState = Object.assign({}, this.state.modal, { open: false });

        this.setState({ modal: modalState });
    }

    getCurrentModalComponent() {
        if (this.state.modal.page && this.modals[this.state.modal.page]) {
            let ModalComponent = this.modals[this.state.modal.page];

            return <ModalComponent {...this.state} />
        } else {
            return null;
        }
    }

    getCurrentPageComponent() {
        if (this.state.page && this.pages[this.state.page]) {
            let CurrentPage = this.pages[this.state.page];

            let defaultPageProps = {
                showModal: this.showModalHandler,
                onPageSuccess: this.onPageSuccessHandler.bind(this),
                ...this.state
            }

            let specificPageProps;

            switch (this.state.page) {
                case 'creer-courriel':
                    specificPageProps = {
                        token: this.state.user.tokenCourriel
                    };
                    
                    break;

                case 'verif-courriel':
                    specificPageProps = {
                        token: this.state.user.tokenCourriel,
                        courriel: this.state.user.useremail
                    };
                        
                    break;

                case 'creer-mot-passe': 
                    specificPageProps = {
                        token: this.state.user.tokenCMP
                    };
                    
                    break;

                case 'demande-mot-pagge':
                    specificPageProps = {
                        showModal: this.showModalHandler
                    };

                    break;

                default:
                    specificPageProps = {};
                    break;
            }

            return <CurrentPage {...defaultPageProps} {...specificPageProps} />
        }
    }
    
    /**
     * Fonction de navigation principale durant le processus d'authentification.
     * Cette fonctione est appelée en cas de succès dans la page en cours et permet de passer à la prochaine étape d'authentification.
     * En progressant il est possible d'ajuster le statut de l'usager et d'afficher des messages contextuels sur la prochaine page 'newPage'.
     * 
     * @param {Object} data     key:val du state qui sera affecté via setState(data)
     */
    onPageSuccessHandler(data = {}) {
        let newPage = null;
        let newMode = "panel";

        switch (this.state.page) {
            case "bienvenue":
                newPage = "consignes";
                break;

            case "consignes":
                newPage = 'demande-identifiant'
                break;

            case "demande-identifiant":
                let newUserState = data.user;

                if (newUserState.passwordStatus === 'NON_DEFINI') {
                    newPage = 'creer-mot-passe'
                } else {
                    newPage = 'demande-mot-passe'
                }

                break;

            case "demande-mot-passe":
                if (data.logon.newPage === "creerCourriel") {
                    newPage = 'creer-courriel';
                } else if (data.logon.newPage === "verifCourriel") {
                    newPage = 'verif-courriel';
                } else if (data.logon.newPage === "sendRecoveryCode") {
                    newPage = 'send-recovery-code';
                } else if (data.logon.newPage === "creerMotPasse") {
                    newPage = 'creer-mot-passe';
                } else {
                    newPage = 'questionnaire';
                    newMode = "fullscreen"
                }

                break;

            case "creer-mot-passe":
                if (data.cmp.newPage === "creerCourriel") {
                    newPage = 'creer-courriel';
                } else if (data.cmp.newPage === "verifCourriel") {
                    newPage = 'verif-courriel';
                } else {
                    newPage = 'questionnaire';
                    newMode = "fullscreen"
                }
                
                break

            case "creer-courriel":
                newPage = "questionnaire";
                newMode = "fullscreen"
                break;

            case "verif-courriel":
                newPage = "questionnaire";
                newMode = "fullscreen"
                break;

            case "send-recovery-code":
                newPage = data.sendRC.newPage;
                break;

            case "verif-recovery-code":
                newPage = data.verifRC.newPage;
                break;

            case "confirm-recovery-code":
                newPage = data.confirmRC.newPage;
                break;
                
            default:
                newPage = "erreur404";
                break;
        }

        let newState = Object.assign({}, this.state, { page: newPage, mode: newMode }, data)
        this.setState(newState);
    }
}

export default App;